export default (fill) => (
  `<svg version="1.1" id="Слой_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 103 111" enable-background="new 0 0 103 111" xml:space="preserve">
<g id="Стилеобразующие-элементы-услуг">
	<g id="_x37_" transform="translate(-441.000000, -306.000000)">
		<g id="kvalifikation" transform="translate(441.000000, 306.000000)">
			<path id="Fill-1" fill="${fill? fill : '#5EB346'}" d="M102.1,37c-0.6-5.7-4.8-13.1-9.4-16.5c0,0-6.8-5.1-15.4-10.1c-8.6-5-16.3-8.5-16.3-8.5
				c-2.6-1.2-6-1.7-9.4-1.7c-3.4,0-6.8,0.6-9.4,1.7c0,0-7.7,3.5-16.3,8.5c-8.5,5-15.4,10.1-15.4,10.1C6.2,23.8,2,31.3,1.3,37
				c0,0-0.9,8.5-0.9,18.6c0,10,0.9,18.6,0.9,18.6c0.6,5.7,4.8,13.1,9.4,16.5c0,0,6.8,5.1,15.4,10.1c8.5,5,16.3,8.5,16.3,8.5
				c2.6,1.2,6,1.7,9.4,1.7c3.4,0,6.8-0.6,9.4-1.7c0,0,7.7-3.5,16.3-8.5c8.5-5,15.4-10.1,15.4-10.1c4.6-3.4,8.8-10.8,9.4-16.5
				c0,0,0.9-8.5,0.9-18.6C103,45.5,102.1,37,102.1,37L102.1,37z M97.4,73.6c-0.5,4.4-4,10.6-7.5,13.2c-0.1,0-6.7,5-14.9,9.8
				c-8.2,4.8-15.7,8.2-15.8,8.3c-1.9,0.8-4.6,1.3-7.4,1.3s-5.6-0.5-7.4-1.3c-0.1,0-7.6-3.4-15.8-8.3c-8.2-4.8-14.9-9.8-14.9-9.8
				c-3.5-2.6-7-8.8-7.5-13.2c0-0.1-0.9-8.4-0.9-18.1c0-9.7,0.9-18,0.9-18.1c0.5-4.4,4-10.6,7.5-13.2c0.1,0,6.7-5,14.9-9.8
				c8.2-4.8,15.7-8.2,15.8-8.3c1.9-0.8,4.6-1.3,7.4-1.3s5.6,0.5,7.4,1.3c0.1,0,7.6,3.4,15.8,8.3c8.2,4.8,14.9,9.7,14.9,9.8
				c3.5,2.6,7,8.8,7.5,13.2c0,0.1,0.9,8.4,0.9,18.1C98.3,65.2,97.4,73.5,97.4,73.6L97.4,73.6z"/>
			<path id="Fill-2" fill="${fill? fill : '#5EB346'}" d="M52.5,84.2c-6.1,0-12.9-5.5-18.8-15.1C28.3,60.3,25,50,24.8,41.3c-0.5-0.8-0.2-1.7-0.2-1.8
				c0.2-0.6,0.9-2,3.2-1.5c5.6,1.3,16.1,2.4,23-4.5c0.9-0.9,2.4-0.9,3.3,0c4.7,4.7,12.9,6.3,23,4.5c2.2-0.4,3,0.7,3.3,1.6
				c0,0.1,0.2,0.9-0.2,1.7C79.7,62.2,63.8,84.2,52.5,84.2L52.5,84.2z M29.6,43.1c1.3,17.1,14.5,36.4,22.9,36.4
				c8.4,0,21.6-19.3,22.9-36.5C66,44.2,58,42.6,52.5,38.3C45.3,44.2,36,44.1,29.6,43.1L29.6,43.1z"/>
			<path fill="${fill? fill : '#5EB346'}" d="M75.6,53.9H29.5c-1.1,0-2-0.9-2-2s0.9-2,2-2h46.1c1.1,0,2,0.9,2,2S76.7,53.9,75.6,53.9z"/>
		</g>
	</g>
</g>
</svg>
`
)


// WEBPACK FOOTER //
// ./components/Icon/icons/uslugas/40.jsx